// ── Application-wide constants ─────────────────────────────────────────────

/** Site metadata */
export const SITE = {
    name: 'VisionAI',
    tagline: 'Sovereign Edge AI for Vision',
    description: 'Train, deploy, and scale Vision AI across edge infrastructure — powered by EdgeMind, presented by Elliance.',
    url: 'https://edgemind-vision.elliancesystem.com/',
    email: 'enquiry@elliancesystem.com',
    // phone: '+1 (555) 123-4567',
    address: 'Elliance — Powering the Next Generation of Edge AI Systems',
};

/** Main navigation links (5 menus + Home) */
export const NAV_LINKS = [
    { label: 'Home', href: '/' },
    { label: 'Products', href: '/products' },
    { label: 'Services', href: '/services' },
    { label: 'User Guide', href: '/user-guide' },
    { label: 'Features', href: '/features' },
    { label: 'Industry 4.0 Technologies', href: 'https://elliancesystem.com/?ref=edgemind', target: '_blank' }
    // { label: 'Solutions', href: '/solutions' },
    // { label: 'Blog', href: '/blog' },
];

/** Breakpoints (px) — mirrors Tailwind defaults */
export const BREAKPOINTS = {
    xs: 480,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536,
};

/** Animation durations (ms) */
export const ANIMATION = {
    fast: 150,
    normal: 250,
    slow: 400,
};

/** API base URL — override via VITE env variable */
export const API_BASE_URL = 'https://edgemind-api.elliancesystem.com';

// export const API_BASE_URL = 'http://localhost:5000';

/** Social links */
export const SOCIAL_LINKS = [
    { platform: 'LinkedIn', href: 'https://www.linkedin.com/company/elliance-sdn-bhd/posts/?feedView=all', icon: 'linkedin' },
    // { platform: 'Twitter/X', href: 'https://twitter.com/elliance', icon: 'twitter' },
    // { platform: 'GitHub', href: 'https://github.com/elliance', icon: 'github' },
    { platform: 'YouTube', href: 'https://www.youtube.com/@ellianceservices3615', icon: 'youtube' },
];
